import { useMutation } from '@tanstack/react-query';

import { API_ROUTES } from '@/query/routes.ts';
import axiosInstance from '@/utils/api/axios-instance.ts';

const useNewReleaseToastSeen = () => {
  return useMutation({
    mutationKey: ['new-release-toast-seen'],

    mutationFn: async (releaseId?: string) => {
      if (!releaseId) {
        return Promise.resolve(null);
      }

      const response = await axiosInstance.post(API_ROUTES.newReleaseNoteSeen(), {
        releaseId,
      });

      return response.data;
    },
  });
};

export default useNewReleaseToastSeen;
